import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { DiscrepancyModal } from "../../components/DiscrepancyModal";
import { useResolveAttachmentDiscrepancy } from "../../data/documentDiscrepancy";
import { capitalize } from '@applyboard/ui-utils';
import { useToasts } from '@applyboard/crystal-ui';
export function ResolveAttachmentDiscrepancyModal(_ref) {
  var attachmentId = _ref.attachmentId,
    documentDiscrepancy = _ref.documentDiscrepancy,
    onClose = _ref.onClose,
    onResolve = _ref.onResolve,
    open = _ref.open;
  var _useResolveAttachment = useResolveAttachmentDiscrepancy(),
    resolveAttachmentDiscrepancy = _useResolveAttachment.resolveAttachmentDiscrepancy,
    isLoadingResolveAttachmentDiscrepancy = _useResolveAttachment.isLoadingResolveAttachmentDiscrepancy;
  var discrepancyOptions = convertDiscrepanciesToOptionsList((documentDiscrepancy === null || documentDiscrepancy === void 0 ? void 0 : documentDiscrepancy.discrepancies) || []);
  var toasts = useToasts();
  return /*#__PURE__*/React.createElement(DiscrepancyModal, {
    open: open,
    onClose: onClose,
    onSubmit: function onSubmit(fields) {
      resolveAttachmentDiscrepancy({
        requestType: documentDiscrepancy.type === 'passport_discrepancy' ? 'resolve_passport_discrepancy' : 'resolve_ielts_discrepancy',
        attachmentId: attachmentId,
        fields: fields
      }, {
        onSuccess: function onSuccess() {
          toasts.positive('Successfully resolved discrepancies');
          onResolve();
          onClose();
        },
        onError: function onError(err) {
          toasts.negative(err instanceof Error ? err : new Error('An error ocurred while trying to resolve discrepancies.'));
          onClose();
        }
      });
    },
    submitting: isLoadingResolveAttachmentDiscrepancy,
    discrepancyIncomingLabel: documentDiscrepancy.type === 'passport_discrepancy' ? 'Passport OCR' : 'IELTS OCR',
    title: documentDiscrepancy.type === 'passport_discrepancy' ? 'Resolve Passport Discrepancies' : 'Resolve IELTS Discrepancies',
    discrepancyMessage: "Student data from the document doesn't match the existing data in the student profile",
    discrepancyOptions: discrepancyOptions
  });
}
function convertDiscrepanciesToOptionsList(discrepancies) {
  return discrepancies.map(function (discrepancy) {
    var currentLabel = discrepancy.current;
    var verifiedLabel = discrepancy.verified;
    if (discrepancy.display_name === 'Gender') {
      currentLabel = capitalize(discrepancy.current);
      verifiedLabel = capitalize(discrepancy.verified);
    }
    if (!currentLabel && currentLabel !== 0) {
      currentLabel = 'N/A';
    }
    if (!verifiedLabel && verifiedLabel !== 0) {
      verifiedLabel = 'N/A';
    }
    return {
      label: discrepancy.display_name,
      field: discrepancy.field,
      options: [{
        label: currentLabel,
        value: discrepancy.current
      }, {
        label: verifiedLabel,
        value: discrepancy.verified
      }]
    };
  }).sort(function (a, b) {
    return a.label.localeCompare(b.label);
  });
}